import { isNonNullType, isListType, Kind, isInputObjectType, isEnumType, isScalarType } from "graphql";
function scalarToValueNode(type, raw) {
  if (raw === "") {
    return void 0;
  }
  if (isEnumType(type)) {
    return {
      kind: Kind.ENUM,
      value: raw
    };
  }
  switch (type.name) {
    case "Int": {
      const n = Number(raw);
      if (!Number.isFinite(n)) {
        return void 0;
      }
      const int = Math.trunc(n);
      if (!Number.isSafeInteger(int)) {
        return void 0;
      }
      return {
        kind: Kind.INT,
        value: String(int)
      };
    }
    case "Float": {
      const n = Number(raw);
      if (!Number.isFinite(n)) {
        return void 0;
      }
      return {
        kind: Kind.FLOAT,
        value: String(n)
      };
    }
    case "Boolean":
      return {
        kind: Kind.BOOLEAN,
        value: raw === "true"
      };
    case "String":
    case "ID":
      return {
        kind: Kind.STRING,
        value: raw
      };
    default:
      return {
        kind: Kind.STRING,
        value: raw
      };
  }
}
function valueNodeToArgValue(node) {
  switch (node.kind) {
    case Kind.LIST:
      return node.values.map(valueNodeToArgValue);
    case Kind.OBJECT: {
      const obj = {};
      for (const f of node.fields) {
        obj[f.name.value] = valueNodeToArgValue(f.value);
      }
      return obj;
    }
    case Kind.INT:
    case Kind.FLOAT:
    case Kind.STRING:
    case Kind.ENUM:
      return node.value;
    case Kind.BOOLEAN:
      return node.value ? "true" : "false";
    default:
      return "";
  }
}
function rawToValueNode(raw) {
  {
    return void 0;
  }
}
function argValueToValueNode(type, value) {
  if (isNonNullType(type)) {
    return argValueToValueNode(type.ofType, value);
  }
  if (isListType(type)) {
    const items = Array.isArray(value) ? value : [];
    const values = [];
    for (const item of items) {
      const node = argValueToValueNode(type.ofType, item);
      if (node !== void 0) {
        values.push(node);
      }
    }
    if (values.length === 0) {
      return void 0;
    }
    const listNode = {
      kind: Kind.LIST,
      values
    };
    return listNode;
  }
  if (isInputObjectType(type)) {
    const obj = !Array.isArray(value) && typeof value === "object" && value !== null ? value : {};
    const fields = type.getFields();
    const objectFields = [];
    for (const [fieldName, fieldDef] of Object.entries(fields)) {
      const fieldVal = obj[fieldName];
      if (fieldVal === void 0) {
        continue;
      }
      const fieldNode = argValueToValueNode(fieldDef.type, fieldVal);
      if (fieldNode === void 0) {
        continue;
      }
      objectFields.push({
        kind: Kind.OBJECT_FIELD,
        name: {
          kind: Kind.NAME,
          value: fieldName
        },
        value: fieldNode
      });
    }
    if (objectFields.length === 0) {
      return void 0;
    }
    const objectNode = {
      kind: Kind.OBJECT,
      fields: objectFields
    };
    return objectNode;
  }
  if (isEnumType(type) || isScalarType(type)) {
    const raw = typeof value === "string" ? value : "";
    return scalarToValueNode(type, raw);
  }
  return void 0;
}
export {
  argValueToValueNode,
  rawToValueNode,
  scalarToValueNode,
  valueNodeToArgValue
};
//# sourceMappingURL=arg-value.js.map
